import { Services } from '@sigma-frontend-libs/commons'

import { getLocaleDateString, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: Boolean,

    OwnerId: {
      type: String,
      default: undefined
    }
  },

  computed: {
    dateRange() {
      const min = new Date()

      return {
        min,
        max: new Date(min.getFullYear() + 1, min.getMonth(), min.getDate())
      }
    },

    validation() {
      if (this.proxy.description) {
        return true
      }

      return false
    },

    hasPermissions() {
      return this.checkPermissions([ `advanced.${Services.tokens}.create`, `advanced.${Services.tokens}.update` ])
    },

    expiredAtTitle() {
      if (this.proxy.expiredAt) {
        return getLocaleDateString(this.proxy.expiredAt)
      } else {
        let key = `${Services.tokens}.titles.expiredAt`
        if (!this.isNew) {
          key = `${Services.tokens}.labels.noData.expiredAt`
        }

        return this.getTranslate(key)
      }
    }
  },

  watch: {
    OwnerId(value) {
      this.proxy.OwnerId = value || this.account.id
    },

    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.proxy.OwnerId = this.OwnerId || this.account.id
    this.$emit('validation', this.validation)
  },

  render
}
